import React from "react";
import { auth } from '../../config/firebaseConfig';
import { Box, Typography } from "@mui/material";
import MatchCard from "./MatchCard";
import ClaimForm from "./ClaimForm";
import ClaimReceipt from "./ClaimReceipt";

const ResultView = ({ 
  searchResults, 
  isFlipped, 
  onFileClaim, 
  formData, 
  onInputChange, 
  onBackToMatch, 
  onSubmitClaim,
  qrPayload,
  onGoToHistory,
  isMobile 
}) => {
  const user = auth.currentUser;
  const fullName = user?.displayName || "";
  const email = user?.email || "";
  const bestMatch = searchResults?.length > 0
    ? searchResults.reduce((prev, current) =>
        current.final_score > prev.final_score ? current : prev
      )
    : null;

  return (
    <Box sx={{ mt: 6, mb: 4 }}>
      {bestMatch ? (
        <Box sx={{
          bgcolor: '#fff',
          borderRadius: 4,
          boxShadow: 2,
          p: { xs: 2, md: 4 },
          maxWidth: 800,
          mx: 'auto',
        }}>
          <Typography 
            variant="h4" 
            sx={{ 
              mb: 4, 
              fontWeight: 600,
              color: "#344b35",
              fontFamily: "Poppins, Helvetica",
              textAlign: "left",
              fontSize: isMobile ? "24px" : "32px"
            }}
          >
            {qrPayload ? "Claim Submitted" : (isFlipped ? "File a Claim" : "Top Match")}
          </Typography>

          <Box
            sx={{
              perspective: "1000px",
              maxWidth: "800px",
              mx: "auto"
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                transition: "transform 0.8s",
                transformStyle: "preserve-3d",
                transform: isFlipped ? "rotateY(180deg)" : "rotateY(0)",
              }}
            >
              {/* Front of card - Match Details */}
              <MatchCard 
                match={bestMatch} 
                onFileClaim={onFileClaim}
                isMobile={isMobile}
              />

              {/* Back of card - Claim Form */}
              {qrPayload ? (
                <ClaimReceipt 
                  qrPayload={qrPayload}
                  onGoToHistory={onGoToHistory}
                  isMobile={isMobile}
                  onBack={onBackToMatch}
                />
              ) : (
                <ClaimForm 
                  formData={{
                    ...formData,
                    fullName: formData.fullName || fullName,
                    email: formData.email || email
                  }}
                  onInputChange={onInputChange}
                  onBack={onBackToMatch}
                  onSubmit={onSubmitClaim}
                  isMobile={isMobile}
                />
              )}
            </Box>
          </Box>
        </Box>
      ) : (
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Typography 
            variant="h5" 
            sx={{ 
              color: "#c74f4f",
              fontWeight: 600,
              fontFamily: "Poppins, Helvetica",
              mb: 2
            }}
          >
            No matches found
          </Typography>
          <Typography 
            sx={{ 
              color: "#516d4f",
              fontSize: "16px"
            }}
          >
            Try adjusting your search terms or uploading a different image
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ResultView;
